import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { CommonService } from '../../service/common/common.service';
import { CsChatIconService } from '../../service/cs-chat-icon/cs-chat-icon.service';

@Component({
  selector: 'app-cs-private-chat-icon',
  templateUrl: './cs-private-chat-icon.component.html',
  styleUrls: ['./cs-private-chat-icon.component.scss']
})
export class CsPrivateChatIconComponent implements OnInit, AfterViewInit {

  @ViewChild('chatIcon', { static: false }) chatIcon!: ElementRef;

  mediaServer: string = '';
  url: string = '';
  private offsetX: number = 0;
  private offsetY: number = 0;
  private isDragging: boolean = false;
  private isMoved: boolean = false;
  private selectedElement: EventTarget | null = null;

  constructor(
    private commonService: CommonService,
    private csChatIconService: CsChatIconService,
    private renderer: Renderer2
  ) {
    this.commonService.mediaServer$.subscribe(mediaServer => {
      this.mediaServer = mediaServer;
    });
  }

  ngOnInit(): void {
    this.loadUrl();
  }

  ngAfterViewInit(): void {
    const chatIconEl = this.chatIcon.nativeElement;
    let startX = 0;
    let startY = 0;
  
    const startDrag = (event: MouseEvent | TouchEvent) => {
      event.preventDefault();
    
      this.isDragging = true;
      this.selectedElement = event.target;
    
      const clientX = (event as TouchEvent).touches ? 
        (event as TouchEvent).touches[0].clientX : 
        (event as MouseEvent).clientX;
      const clientY = (event as TouchEvent).touches ? 
        (event as TouchEvent).touches[0].clientY : 
        (event as MouseEvent).clientY;

      startX = clientX;
      startY = clientY;
    
      this.offsetX = clientX - chatIconEl.getBoundingClientRect().left;
      this.offsetY = clientY - chatIconEl.getBoundingClientRect().top;
    };
    
    const moveDrag = (event: MouseEvent | TouchEvent) => {
      if (!this.isDragging) return;
    
      const clientX = (event as TouchEvent).touches ? 
        (event as TouchEvent).touches[0].clientX : 
        (event as MouseEvent).clientX;
      const clientY = (event as TouchEvent).touches ? 
        (event as TouchEvent).touches[0].clientY : 
        (event as MouseEvent).clientY;
    
      let newX = clientX - this.offsetX;
      let newY = clientY - this.offsetY;

      if (Math.abs(clientX - startX) > 5 || Math.abs(clientY - startY) > 5) {
        this.isMoved = true;
      }
    
      const maxX = window.innerWidth - chatIconEl.offsetWidth;
      const maxY = window.innerHeight - chatIconEl.offsetHeight;
    
      newX = Math.max(0, Math.min(newX, maxX));
      newY = Math.max(0, Math.min(newY, maxY));
    
      this.renderer.setStyle(chatIconEl, 'left', `${newX}px`);
      this.renderer.setStyle(chatIconEl, 'top', `${newY}px`);
      this.renderer.setStyle(chatIconEl, 'position', 'fixed');
    };    
  
    const stopDrag = () => {
      this.isDragging = false;

      if(!this.isMoved && chatIconEl.contains(this.selectedElement)){
        this.onCsChatIconClick();
      }
      
      this.isMoved = false;
      this.selectedElement = null;
    };
  
    this.renderer.listen(chatIconEl, 'mousedown', startDrag);
    this.renderer.listen(chatIconEl, 'touchstart', startDrag);
  
    this.renderer.listen(document, 'mousemove', moveDrag);
    this.renderer.listen(document, 'touchmove', moveDrag);
  
    this.renderer.listen(document, 'mouseup', stopDrag);
    this.renderer.listen(document, 'touchend', stopDrag);
  }  

  onCsChatIconClick(): void {
    window.open(this.url, '_blank');
  }

  loadUrl(): void {
    this.csChatIconService.getCsChatUrl().subscribe(
      response => this.url = response.data.ktoCsUrl
    );
  }

}